import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/ContextData';
import AlertMessage from '../../components/modals/AlertMessage';
import DealerConnectModal from '../../components/modals/DealerConnectModal';
import DemoModal from '../../components/modals/DemoModal';
import ShareModal from '../../components/modals/ShareModal';
import Paginations from '../../components/Pagenation';

const MobMoreProducts = ({ title, heading_css, breadcrum, data, page, pages, setPage }) => {
    const navigate = useNavigate()

    const [xsType, setXsType] = useState(12);
    const [show, setShow] = useState(false);
    const [showShare, setShowShare] = useState(false);
    const [shareUrl, setShareUrl] = useState('');
    const [title1, setTitle] = useState('');
    const [delaerShow, setDelaerShow] = useState(false);
    const [demoToast, setDemoToast] = useState(false);

    const hostname = document.location.origin;

    const [isSticky, setSticky] = useState(false);
    const ref = useRef(null);
    const handleScroll = () => {
        if (ref.current) {
            setSticky(ref.current.getBoundingClientRect().top <= 0);
            // setUnSticky(true)
        }
    };

    useEffect(() => {

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', () => handleScroll,);
        };
    }, []);
    const [showToast, setShowToast] = useState(false);
    const [reqType, setReqType] = useState("");

    const { wished, setWished, removeWished, setRemoveWished, cart, setCart, removeCart, setRemoveCart, demo, dealerId } = useAuth()

    // ---------------------------Wished Items------------------------
    const localWished = JSON.parse(localStorage.getItem("wished"))
    useEffect(() => {
        if (localWished && wished.length === 0) {
            if (removeWished === 0) {
                localStorage.removeItem("wished")
            } else {
                setWished(...wished, localWished)
            }
        }
        if (wished.length !== 0) {
            localStorage.setItem("wished", JSON.stringify(wished))
        }

    }, [wished, setWished, localWished, removeWished,])

    // ---------------------------Cart Items------------------------
    const localCart = JSON.parse(localStorage.getItem("cart"))
    useEffect(() => {
        if (localCart && cart.length === 0) {
            if (removeCart === 0) {
                localStorage.removeItem("cart")
            } else {
                setCart(...cart, localCart)
            }
        }
        if (cart.length !== 0) {
            localStorage.setItem("cart", JSON.stringify(cart))
        }

    }, [cart, setCart, localCart, removeCart,])

    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
    const myRef = useRef(null)

    const onPageChanged = useCallback(
        (event, page) => {
            event.preventDefault();
            setPage(page);
            scrollToRef(myRef)
        },
        [setPage]
    );

    return (
        <React.Fragment>
            <ShareModal
                show={showShare}
                setShowShare={() => setShowShare(false)}
                url={shareUrl}
                title={title1}
            />
            <DealerConnectModal
                show={delaerShow}
                setShow={setDelaerShow}
            />
            <AlertMessage
                show={showToast}
                setShow={() => setShowToast(false)}
                reqType={reqType}
            />
            <DemoModal
                show={demoToast}
                setShow={setDemoToast}
            />
            <div className="mainWidth cp">
                <h1 className={heading_css ? heading_css : "text-center fs-6 cpm"}>{title} {breadcrum && '-'} {breadcrum}</h1>
                <div className={`sticky-wrapper ${isSticky ? 'sticky' : ''}`} ref={ref}>
                    <div className={isSticky === true ? 'sticky-inner' : ''}>
                        <Row className="mx-0  bg-white py-1">
                            <Col xs="9 d-flex align-items-center mutetedText">
                                <div onClick={() => setShow(true)}>
                                    <img
                                        src="/assets/icons/sort.svg"
                                        alt="Sort"
                                        className="me-2"
                                        width="23"
                                        height="15"
                                    />
                                    <div className="filterTxt ps-1">Sort</div>
                                </div>
                                <div className="ms-1 text-center">
                                    <input type="text" className="inputQty  text-muted fs12" />
                                    <div className="filterTxt ">Filter By Quantity</div>
                                </div>

                            </Col>
                            <Col xs="3 d-flex justify-content-end pe-2">
                                <div className="me-1">
                                    <img
                                        src={xsType === 6 ? "/assets/icons/grid_black.svg" : "/assets/icons/grid.svg"}
                                        onClick={() => setXsType(6)}
                                        alt="grids"
                                        className="me-2 mouse"
                                        width="20"
                                        height="20"
                                    />
                                    {xsType === 6 ? <div className="filterTxt cpm ps-1">Grid</div> : <div className="filterTxt ps-1">Grid</div>}

                                </div>
                                <div className="ms-1">
                                    <img
                                        src={xsType === 12 ? "/assets/icons/list.svg" : "/assets/icons/list_grey.svg"}
                                        onClick={() => setXsType(12)}
                                        alt="List"
                                        className="mouse"
                                        width="20"
                                        height="20"
                                    />
                                    {xsType === 12 ? <div className="filterTxt cpm ps-1">List</div> : <div className="filterTxt ps-1">List</div>}

                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                <Row className="mx-0 mb-2">
                    {data.length > 0 ? data.map((item, index) => (
                        <Col
                            xs={xsType}
                            key={index}
                            className={`${xsType === 6 ? (index % 2 === 0) === true ? "pe_7" : "ps_7" : "px-1"} mt-2`}
                        >
                            <Link to={'/productdetails/' + (item.title && item.title.replace(/[\s,-;]+/g, "-").toLowerCase()) + "/" + item.itemNo + (dealerId && "?dealerId=" + dealerId)}>
                                <img src={process.env.REACT_APP_S3URL + item.masterimg} alt={item.itemNo} className={`w-100 ${xsType === 6 ? '' : 'img534'}`} />
                            </Link>
                            <Row className="mx-2 align-items-center">
                                <Col
                                    xs={`10 px-0 mutetedText ${xsType === 6 ? "fs10 mp_text_length ls12 mt-1" : "fs18 text-truncate"
                                        }`}
                                >
                                    <h2 className={xsType === 6 ? "fs10 mp_text_length ls12 mt-1" : "fs18 text-truncate"}>{item.title}</h2>
                                </Col>
                                <Col xs="2 text-end px-0">
                                    <img
                                        src="/assets/icons/share.png"
                                        alt="share"
                                        className="lgIconImgs mouse"
                                        onClick={() => { setShowShare(true); setTitle(item.title); setShareUrl(hostname + '/productdetails/' + (item.title && item.title.replace(/[\s,-;]+/g, "-").toLowerCase()) + "/" + item.itemNo) }}
                                    />
                                </Col>
                                <Col className="px-0">
                                    {item.price && <div className="cpm fs_13">&#8377; {item.price}/{item.unit} </div>}
                                </Col>
                                <Col className=" d-flex px-0 text-end">
                                    <div className="w-100">
                                        <img src={
                                            wished.find(obj => obj.itemNo === item.itemNo)
                                                ? "/assets/icons/wished.png" : "/assets/icons/wish.svg"}
                                            alt="wish"
                                            className="me-2 mouse"
                                            width="16"
                                            height="16"
                                            onClick={() => {
                                                if (demo) {
                                                    setDemoToast(true)
                                                }
                                                else if (!dealerId) {
                                                    setDelaerShow(true)
                                                }
                                                else if (wished.find(obj => obj.itemNo === item.itemNo)) {
                                                    if (wished.length === 1) {
                                                        setRemoveWished(0)
                                                        setReqType("removeWished")
                                                    }
                                                    const x = wished.indexOf(wished.find(obj => obj.itemNo === item.itemNo))
                                                    wished.splice(x, 1)
                                                    setWished([...wished])
                                                    setReqType("removeWished")
                                                }
                                                else if (cart.find(obj => obj.itemNo === item.itemNo)) {
                                                    if (cart.length === 1) {
                                                        setRemoveCart(0)
                                                        setWished([...wished, item])
                                                        setReqType("moveWished")
                                                        setShowToast(true)
                                                    }
                                                    const x = cart.indexOf(cart.find(obj => obj.itemNo === item.itemNo))
                                                    cart.splice(x, 1)
                                                    setCart([...cart])
                                                    setWished([...wished, item])
                                                    setReqType("moveWished")
                                                    setShowToast(true)
                                                }
                                                else {
                                                    setWished([...wished, item])
                                                    setReqType("addWished")
                                                    setShowToast(true)
                                                }
                                            }} />

                                        <img
                                            src={cart.find(obj => obj.itemNo === item.itemNo) ? "/assets/icons/bagGreen.svg" : "/assets/icons/bag.svg"}
                                            alt="cart"
                                            className="mouse"
                                            width="16"
                                            height="16"
                                            onClick={() => {
                                                if (demo) {
                                                    setDemoToast(true)
                                                }
                                                else if (!dealerId) {
                                                    setDelaerShow(true)
                                                }
                                                else if (cart.find(obj => obj.itemNo === item.itemNo)) {
                                                    navigate("/checkout/cart")
                                                }
                                                else if (wished.find(obj => obj.itemNo === item.itemNo)) {
                                                    if (wished.length === 1) {
                                                        setRemoveWished(0)
                                                        setCart([...cart, item])
                                                        setReqType("moveCart")
                                                        setShowToast(true)
                                                    }
                                                    const x = wished.indexOf(wished.find(obj => obj.itemNo === item.itemNo))
                                                    wished.splice(x, 1)
                                                    setWished([...wished])
                                                    setCart([...cart, item])
                                                    setReqType("moveCart")
                                                    setShowToast(true)
                                                }
                                                else {
                                                    setCart([...cart, item])
                                                    setReqType("addCart")
                                                    setShowToast(true)
                                                }
                                            }} />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    )) :
                        <h5>There Are No Products</h5>
                    }
                </Row>
                {pages > 1 &&
                    <Paginations
                        pageNeighbours={3}
                        onPageChanged={onPageChanged}
                        currentPage={page}
                        totalPages={pages}
                    />
                }

            </div>

            <Modal show={show} onHide={() => setShow(false)} className="cpm tw_center mm_model mainWidth dc_model dc_model_radious dc_model_fade position-sticky bottom-0">

                <Modal.Body className="px-0">
                    <div className="textAlign fs24 ">Sort By</div>
                    <Form.Label className="w-100" onClick={() => setShow(false)}>
                        <Row className="mx-0  border-bottom py-1">
                            <Col className="text-start">
                                <span>Popularity</span>
                            </Col>
                            <Col className="text-end">
                                <Form.Check className="float-end"
                                    type="radio"
                                    name="a"
                                    id="radio1"
                                />
                            </Col>
                        </Row>
                    </Form.Label>
                    <Form.Label className="w-100" onClick={() => setShow(false)}>
                        <Row className="mx-0  border-bottom py-1">
                            <Col className="text-start">
                                <span>Price-Low to High</span>
                            </Col>
                            <Col className="text-end">
                                <Form.Check className="float-end"
                                    type="radio"
                                    name="a"
                                    id="radio1"
                                />
                            </Col>
                        </Row>
                    </Form.Label>
                    <Form.Label className="w-100" onClick={() => setShow(false)}>
                        <Row className="mx-0  border-bottom py-1">
                            <Col className="text-start">
                                <span>Price-High to Low</span>
                            </Col>
                            <Col className="text-end">
                                <Form.Check className="float-end"
                                    type="radio"
                                    name="a"
                                    id="radio1"
                                />
                            </Col>
                        </Row>
                    </Form.Label>
                    <Form.Label className="w-100" onClick={() => setShow(false)}>
                        <Row className="mx-0 border-bottom py-1">
                            <Col className="text-start">
                                <span>Newest First</span>
                            </Col>
                            <Col className="text-end">
                                <Form.Check className="float-end"
                                    type="radio"
                                    name="a"
                                    id="radio1"
                                />
                            </Col>
                        </Row>
                    </Form.Label>
                    <Form.Label className="w-100">
                        <Form.Check className="float-end d-none"
                            type="radio"
                            name="a"
                            id="radio1"
                        />
                        <Row className="mx-0 mb-4 py-1 align-items-center">
                            <Col xs="4 p-0 text-start ps-2">
                                <span className='ps-1'>Price Range:</span>
                            </Col>
                            <Col xs="2 px-0 ">
                                <div className="d-flex">
                                    &#8377;
                                    <input type="text" className="w-100 ms-2  height22" />
                                </div>
                            </Col>
                            <Col xs="2 ps-0 text-center">
                                to
                            </Col>
                            <Col xs="2 px-0 ">
                                <div className="d-flex">
                                    &#8377;
                                    <input type="text" className="w-100 ms-2 height22" />
                                </div>
                            </Col>

                            <Col xs="2  text-center mouse" onClick={() => setShow(false)}>
                                Apply
                            </Col>

                        </Row>
                    </Form.Label>


                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default MobMoreProducts
